import { fill, zipObject } from 'lodash';

export const generateCustomColorGroup = ({
  colorGroupId,
  fields,
  groupColor,
}: {
  colorGroupId: string;
  fields: string[];
  groupColor: string;
}) => {
  const customColorGroup = {
    [colorGroupId]: groupColor,
    ...zipObject(fields, fill(Array(fields.length), groupColor)),
  };
  return customColorGroup;
};
